import React from 'react'

const DoubleLeafIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="47"
      viewBox="0 0 60 47"
      fill="none"
      {...props}
    >
      <path
        d="M5.27667 42.1136C1.84333 38.4669 0 34.3769 0 27.7469C0 16.0803 8.19 5.62361 20.1 0.453613L23.0767 5.04695C11.96 11.0603 9.78667 18.8636 8.92 23.7836C10.71 22.8569 13.0533 22.5336 15.35 22.7469C21.3633 23.3036 26.1033 28.2403 26.1033 34.3769C26.1033 37.4711 24.8742 40.4386 22.6862 42.6265C20.4983 44.8145 17.5309 46.0436 14.4367 46.0436C12.7255 46.0288 11.0344 45.6738 9.46176 44.9991C7.88915 44.3243 6.46651 43.3435 5.27667 42.1136ZM38.61 42.1136C35.1767 38.4669 33.3333 34.3769 33.3333 27.7469C33.3333 16.0803 41.5233 5.62361 53.4333 0.453613L56.41 5.04695C45.2933 11.0603 43.12 18.8636 42.2533 23.7836C44.0433 22.8569 46.3867 22.5336 48.6833 22.7469C54.6967 23.3036 59.4367 28.2403 59.4367 34.3769C59.4367 37.4711 58.2075 40.4386 56.0196 42.6265C53.8317 44.8145 50.8642 46.0436 47.77 46.0436C46.0588 46.0288 44.3677 45.6738 42.7951 44.9991C41.2225 44.3243 39.7998 43.3435 38.61 42.1136Z"
        fill="url(#paint0_linear_497_375)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_497_375"
          x1="29.7183"
          y1="0.453613"
          x2="29.7183"
          y2="46.0436"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgba(58, 175, 248, 1)" />
          <stop
            offset="rgba(15, 153, 238, 1)"
            stopColor="#rgba(15, 153, 238, 1)"
          />
          <stop
            offset="rgba(15, 153, 238, 1)"
            stopColor="rgba(1, 115, 188, 1)"
          />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default DoubleLeafIcon
